import { useState, useCallback } from 'react';
import api from '../api/axios';

export const useAdminData = () => {
  const [tutors, setTutors] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAllData = useCallback(async () => {
    setLoading(true);
    try {
      const [tutorRes, studentRes] = await Promise.all([
        api.get('/admin/tutors'),
        api.get('/admin/students')
      ]);
      setTutors(tutorRes.data);
      setStudents(studentRes.data);
    } catch (err) {
      console.error("Error fetching admin data:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { tutors, students, loading, fetchAllData, setTutors, setStudents };
};